<template>
    <ProfilForm />
</template>

<script src="./js/profilView.js"></script>